export default {
  miningPickaxeCrafting: 'Spitzhacken-Herstellung',
  miningDepthDweller: 'Tiefengräber',
  miningSmeltery: 'Hochofen',
  miningEnhancement: 'Aufwertungen',
  miningResin: 'Harz',
  miningSmoke: 'Rauch',
  miningCompressAluminium: 'Aluminium komprimieren',
  miningCompressCopper: 'Kupfer komprimieren',
  miningCompressTin: 'Zinn komprimieren',
  miningCompressIron: 'Eisen komprimieren',
  miningCompressTitanium: 'Titan komprimieren',
  miningCompressPlatinum: 'Platin komprimieren',
  miningCompressIridium: 'Iridium komprimieren',
  miningCompressOsmium: 'Osmium komprimieren',
  miningCompressLead: 'Blei komprimieren',
  villageBuildings1: 'Stufe-1-Gebäude',
  villageBuildings2: 'Stufe-2-Gebäude',
  villageBuildings3: 'Stufe-3-Gebäude',
  villageBuildings4: 'Stufe-4-Gebäude',
  villageBuildings5: 'Stufe-5-Gebäude',
  villageBuildings6: 'Stufe-6-Gebäude',
  villageBuildings7: 'Stufe-7-Gebäude',
  villageCoinUpgrades: 'Goldmünzen-Verbesserungen',
  villageUpgradeScythe: 'Sense-Verbesserung',
  villageUpgradeHatchet: 'Beil-Verbesserung',
  villageUpgradePickaxe: 'Spitzhacke-Verbesserung',
  villageUpgradeWateringCan: 'Gießkanne-Verbesserung',
  villageUpgradeInvestment: 'Investition-Verbesserung',
  villageUpgradeBasics: 'Grundlagen-Verbesserung',
  villageUpgradeProcessing: 'Verarbeitung-Verbesserung',
  villageUpgradePump: 'Pumpwerk-Verbesserung',
  villageUpgradeSand: 'Sand-Verbesserung',
  villageUpgradeBook: 'Buch-Verbesserung',
  villageUpgradeAxe: 'Axt-Verbesserung',
  villageUpgradeBomb: 'Bombe-Verbesserung',
  villageUpgradeToll: 'Zoll-Verbesserung',
  villageUpgradeFishingRod: 'Angel-Verbesserung',
  villageUpgradeHolyBook: 'Heiliges-Buch-Verbesserung',
  villageUpgradeBreakthrough: 'Durchbruch-Verbesserung',
  villageUpgradeModifiedPlants: 'Modifizierte-Pflanzen-Verbesserung',
  villageUpgradeDopamine: 'Dopamin-Verbesserung',
  villageUpgradeAdrenaline: 'Adrenalin-Verbesserung',
  villageUpgradeSprinkler: 'Rasensprenger-Verbesserung',
  villageUpgradeGreed: 'Gier-Verbesserung',
  villageUpgradeAmbition: 'Ambition-Verbesserung',
  villageUpgradeUnderstanding: 'Verständnis-Verbesserung',
  villageUpgradeCuriosity: 'Neugier-Verbesserung',
  villageUpgradeWorship: 'Verehrung-Verbesserung',
  villageUpgradeBartering: 'Feilschen-Verbesserung',
  villageUpgradeSparks: 'Funken-Verbesserung',
  villageOffering1: 'Opfergaben',
  villageOffering2: 'Stufe-2-Opfergaben',
  villageOffering3: 'Stufe-3-Opfergaben',
  villageOffering4: 'Stufe-4-Opfergaben',
  villageSpecialIngredient: 'Besondere Zutaten',
  hordeCorruptedFlesh: 'Erbeute korruptes Fleisch',
  hordeChessItems: 'Schach-Ausrüstung',
  hordeSacrifice: 'Opfer',
  hordeUpgradeRoyalArmor: 'Königliche-Rüstung-Verbesserung',
  hordeUpgradeRoyalStorage: 'Königliches-Lager-Verbesserung',
  hordeUpgradeRoyalButcher: 'Königlicher-Schlachter-Verbesserung',
  hordeUpgradeRoyalCrypt: 'Königliches-Grab-Verbesserung',
  hordeUpgradeRoyalSecret: 'Königliches-Geheimnis-Verbesserung',
  hordeClassArcher: 'Bogenschützen-Klasse',
  hordeClassMage: 'Magier-Klasse',
  hordeClassKnight: 'Ritter-Klasse',
  hordeClassAssassin: 'Assassine-Klasse',
  hordeClassShaman: 'Schamane-Klasse',
  hordeClassPirate: 'Pirat-Klasse',
  hordeClassUndead: 'Untoter-Klasse',
  hordeClassCultist: 'Kultist-Klasse',
  hordeClassScholar: 'Gelehrter-Klasse',
  farmDisableEarlyGame: 'Deaktiviere "Erste Pflanzen"',
  farmCropExp: 'Pflanzenerfahrung',
  farmFertilizer: 'Dünger',
  galleryConversion: 'Umwandlung',
  galleryInspiration: 'Inspiration',
  galleryAuction: 'Auktionen',
  galleryDrums: 'Farbtrommeln',
  galleryShape: 'Formen',
  galleryCanvas: 'Leinwand',
  treasureDual: 'Doppelte Schätze',
  bloomPoppyFlower: 'Mohn',
  bloomIrisFlower: 'Schwertlilie',
  bloomLilyFlower: 'Lilie',
  bloomOrchidFlower: 'Orchidee',
  bloomCornflowerFlower: 'Kornblume',
  summerFestivalTerraform: 'Terraforming'
};
